import { $document, $window, $htmlBody, $html, $body, $main } from './Variables'
import { scrollTo, getScrollBottom } from './ScrollTo'
import { show, hide } from './Toggle.js'

const element = '.js-back-to-top',
  target = 0,
  offsetY = 0,
  options = {
    ease: Power4.easeInOut,
    position: 200
  }

export default class BackToTop {
  /**
   * [scroll description]
   * @return {[type]} [description]
   */
  static setScroll() {
    scrollTo(element, target, offsetY, options)
  }
  /**
   * [toggle description]
   * @return {[type]} [description]
   */
  static toggle() {
    $window.on('scroll load', function() {
      const $footer = $('footer')
      const position = $window.scrollTop(),
        yFromFotter = getScrollBottom() - $footer.outerHeight(true)

      if (position > options.position && yFromFotter > 0) {
        options.y = 0
        show(element, options)
      } else if (yFromFotter <= 0) {
        options.y = -$footer.outerHeight(true)
        show(element, options)
        // enquire.register('screen and (max-width: 767px)', {
        //   match: function() {
        //     options.y = -$footer.outerHeight(true)
        //     show(element, options)
        //   }
        // })
        // enquire.register('screen and (min-width: 768px)', {
        //   match: function() {
        //     const $footerCopyright = $('.footer__copyright')
        //     const $footerImage = $('.footer__img-wrapper')
        //     options.y = -(
        //       $footerCopyright.outerHeight(true) ||
        //       Number($footerImage.css('margin-bottom').replace('px', ''))
        //     )
        //     show(element, options)
        //   }
        // })
      } else {
        options.y = 200
        hide(element, options)
      }
    })
  }
}
